export default "__VITE_ASSET__Mz2sfDjC__"